import {styled} from '@mui/material';

const HeaderContainer = styled('header')<{$variant: 'default' | 'white'}>`
	background-color: ${({theme, $variant}) =>
		$variant === 'default' ? theme.palette.primary.main : theme.palette.common.white};
	color: ${({theme, $variant}) =>
		$variant === 'default' ? theme.palette.primary.contrastText : theme.palette.text.primary};
	flex-direction: column;
	display: flex;
	padding: 24px 32px;

	${({theme}) => theme.breakpoints.down('md')} {
		padding: 8px 16px;
	}
`;

export {HeaderContainer};
